import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#76a300",
    },
  },
});

const Loading = () => {
  return (
    <ThemeProvider theme={theme}>
      <CircularProgress />
    </ThemeProvider>
  );
};

export default Loading;
